import "../styles/About.css";

function About() {
  return (
    <div className="about" id="about">
      <h1>About Me</h1>
      <p>
        I’m a Front-End Engineer with 3+ years of experience building responsive
        and interactive web applications. I enjoy crafting user interfaces that
        are not only functional but also delightful to use. Recently, I’ve been
        focusing on Web3 development, working with EVM-compatible chains and
        Solana to build blockchain-integrated front-end experiences.
      </p>
      <p>
        I’m proficient in React.js, Next.js, Vue.js, and state management tools
        like Redux, React Context, and Zustand. I’m also a graduate of the
        Front-End Immersive Program at Alterra Academy (Batch 3), and I’m
        passionate about staying up to date with modern web technologies.
      </p>
    </div>
  );
}

export default About;
